import React from 'react';

import DoctorRegistration from './DoctorRegistration'

const App = () => < DoctorRegistration />

export default App;